import { combineReducers } from 'redux';
import LogsReducer from './logsReducer';

const rootReducer = combineReducers({
  logs: LogsReducer,
});

export default rootReducer;
